import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GeolocationService } from '@ng-web-apis/geolocation';
import { Coordinate } from '../data-models/coordinate.model';
import { ConfirmationDialogComponent } from '../dialogs/confirmation-dialog/confirmation-dialog.component';
import { CoordinateDialogComponent } from '../dialogs/coordinate-dialog/coordinate-dialog.component';
import { Subscription } from 'rxjs';
import { AbstractControl } from '@angular/forms';
import { SharedMethodsService } from './shared-methods.service';
import { take } from 'rxjs/operators';

let SCREEN_WIDTH: string =  Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0).toString() + 'px';

@Injectable({
  providedIn: 'root'
})
export class GeolocationMethodsService implements OnDestroy {

  locationSubscription!: Subscription;
  locationAllowed: boolean = false;
  position!: GeolocationCoordinates;

  constructor(private readonly geolocation$: GeolocationService, private dialog: MatDialog, private sharedMethodsService: SharedMethodsService) {
    if (!this.locationSubscription) {
      this.locationSubscription = this.geolocation$.subscribe(pos => {this.position = pos.coords; this.locationAllowed = true;}, err => {
        
        // User has denied permission
        if (err.code == 1) {
          this.sharedMethodsService.toastGeolocationDisabled();
          this.locationAllowed = false;
        }
      });
  
    }
  }


  openCoordinateDialog(latOrLon: string, control: AbstractControl) {
    let w: string = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0).toString() + 'px';

    const dialogRef = this.dialog.open(CoordinateDialogComponent, {
      width: SCREEN_WIDTH > w ? SCREEN_WIDTH : w,
      height: '200px',
      data: {title: latOrLon, coord: control.value},
    });
    
    dialogRef.afterClosed().subscribe((result: Coordinate | undefined) => {
      if (result) control.setValue(result);
      
    })
  }


  fillCoordinatesFromGps(latControl: AbstractControl, lonControl: AbstractControl) {
    let fillFunction = () => {
      if ((!latControl.value || latControl.value.isUnfilled()) && (!lonControl.value || lonControl.value.isUnfilled())) {
        latControl.setValue(Coordinate.fillDegrees(this.position.latitude, false), {emitEvent: false});
        lonControl.setValue(Coordinate.fillDegrees(this.position.longitude, false));
  
      } else {
        this.dialog.open(ConfirmationDialogComponent, {
          data: {screen: 'autofill'}
        }).afterClosed().subscribe(result => {
          if (result) {
            latControl.setValue(Coordinate.fillDegrees(this.position.latitude, false), {emitEvent: false});
            lonControl.setValue(Coordinate.fillDegrees(this.position.longitude, false));
          }
        }); 
      }
    }

    if (!this.locationAllowed || !this.position) {

      this.geolocation$.pipe(take(1)).subscribe(position => { this.position = position.coords; fillFunction();});
      this.locationSubscription = this.geolocation$.subscribe(pos => {this.position = pos.coords; this.locationAllowed = true; }, err => {
        console.log(err)
        // User has denied permission
        if (err.code == 1) {
          this.sharedMethodsService.toastGeolocationDisabledError();
          this.locationAllowed = false;
          return;
        }

      });
    } else {
      fillFunction()
    }

    
  }


  ngOnDestroy(): void {
    if (this.locationSubscription) this.locationSubscription.unsubscribe();
  }
}
